import { INSTALL_COPY } from './installCopy';

/**
 * Block 0 Phase 3 (ADR-0013 §3) — iOS Safari fallback с пошаговой инструкцией
 * по «Поделиться → Добавить на экран Домой». Отдельный компонент для
 * `IOSInstructions.stories.tsx` и независимого юнит-теста (Container просто
 * выбирает между этим и нативным prompt-button по `isIOS()`).
 *
 * Pure presenter: получает только `onClose`. Никакой platform-detection
 * внутри — это работа Container'а. Это позволяет storybook отрендерить
 * inструкции на любой dev-машине без UA-mock.
 *
 * P-019 vertical buttons: одна кнопка «Понятно». Если в Phase 4+ нужен
 * skip — добавить вторым `<button>` под основным с тем же visual style
 * как outline в `PaywallModal`.
 *
 * a11y: `<ol>` вместо `<ul>` — порядок шагов значим. Нумерация font-bold
 * выводится средствами CSS `list-style: decimal`.
 */

export interface IOSInstructionsProps {
  onClose: () => void;
}

export function IOSInstructions({ onClose }: IOSInstructionsProps) {
  return (
    <section className="px-4 py-6 flex flex-col gap-5" aria-labelledby="ios-instructions-title">
      <h1 id="ios-instructions-title" className="font-display text-h1 text-ink">
        {INSTALL_COPY.iosTitle}
      </h1>
      <p className="text-ink text-base leading-snug">{INSTALL_COPY.iosIntro}</p>
      <ol
        className="list-decimal pl-6 flex flex-col gap-3 text-ink text-base leading-snug"
        data-testid="ios-instructions-steps"
      >
        {INSTALL_COPY.iosSteps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
      <button
        type="button"
        onClick={onClose}
        className={
          'w-full font-bold rounded-xl flex items-center justify-center ' +
          'bg-cta text-ink border-b-2 border-cta-shadow min-h-tap-chip-lg ' +
          'focus-visible:ring-2 focus-visible:ring-cta focus-visible:ring-offset-2 ' +
          'focus-visible:outline-none transition-opacity active:opacity-90'
        }
        style={{ fontSize: 19 }}
      >
        {INSTALL_COPY.iosClose}
      </button>
    </section>
  );
}
